module.exports = __webpack_public_path__ + "img/logo-internal.10344036.png";